import { render, staticRenderFns } from "./RoleBreadcrumb.vue?vue&type=template&id=070105f4&scoped=true&"
import script from "./RoleBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RoleBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./RoleBreadcrumb.vue?vue&type=style&index=0&id=070105f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070105f4",
  null
  
)

export default component.exports